import React from 'react';
import NavigationStepper, {
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import PredefinedPhrasesList from './PredefinedPhrasesList';
import { PhraseType } from '../../../../graphql/graphql';

interface Props {
	onEdit?: () => void;
}

const PredefinedPhrasesSetup: React.FC<Props> = ({ onEdit }) => {
	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.predefinedPhrasesSetup.chat',
			key: 'chat',
			component: () => (
				<PredefinedPhrasesList type={PhraseType.Chat} onEdit={onEdit} />
			),
		},
	];

	return (
		<NavigationStepper
			steps={steps}
			showStepNumbers={false}
			canSkip
			initialStepPath='chat'
		/>
	);
};

export default PredefinedPhrasesSetup;
